module.exports = __webpack_public_path__ + "img/icon-lotto-dw.fd8f1e68.png";